import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { decorateUser } from "./_helpers";

export const user_by_id: Query<Ctx> = async ({ sb }, params) => {
  const id = params.get("id");
  if (!id) return null;

  const { data } = await sb
    .from("v_users_list")
    .select("*")
    .eq("id", id)
    .single();
  if (!data) return null;
  return decorateUser(data);
};
